import { render, staticRenderFns } from "./moreShop.vue?vue&type=template&id=5321afd6&scoped=true"
import script from "./moreShop.vue?vue&type=script&lang=js"
export * from "./moreShop.vue?vue&type=script&lang=js"
import style0 from "./moreShop.vue?vue&type=style&index=0&id=5321afd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321afd6",
  null
  
)

export default component.exports